import {createStore} from 'vuex'
import moment from "moment";

export default createStore({
    state: {
        msisdn: undefined,
        serviceId: undefined,
        brandConfig: undefined,
        upcomingFixtures: [],
        showAutoTeamBuilder: false,
        showHowToWinPoints: false,
        isLoading: undefined,
        roundId: undefined,
        leagueName: undefined,
        showSelectCaptain: false,
        showHint: false,
        showTriviaGameOver: false,
        showEditUserName: false,
        showEditAvatar: false,
        showInviteFriend: false,
        showSingleMatch: false,
        showSubUpsell: false,
        showNoQuestions: false,
        productId: 27,
        user: undefined,
        liveRoundsNotEntered: 0,
        roundsEntered: 0,
        predictedDrivers: undefined,
        predictedConstructors: undefined,
        predictedPolePosition: undefined,
        showUpgradeToPremium: false,
        defferedPrompt: null,
        showAddToHomeScreen: false,
        feedArticles: [],
        campaignId: 0,
        clickedTournamentId: undefined,
        completedRounds: [],
        tournamentRoundTimers: {},
        showTournamentModal: false,
        showVoucherEarnedPopup: false,
        myFantasyRounds: undefined,
        myPredictorRounds: undefined
    },
    mutations: {
        setShowVoucherEarnedPopup(state, showVoucherEarnedPopup) {
            state.showVoucherEarnedPopup = showVoucherEarnedPopup
        },
        addCompletedRound(state, { tournamentId, bracketId }) {
            state.completedRounds.push({
                tournamentId,
                bracketId,
                shownAt: moment().toISOString()
            });
        },
        setTournamentRoundTimer(state, { key, timerId }) {
            state.tournamentRoundTimers[key] = timerId;
        },
        clearTournamentRoundTimer(state, key) {
            if (state.tournamentRoundTimers[key]) {
                clearTimeout(state.tournamentRoundTimers[key]);
                delete state.tournamentRoundTimers[key];
            }
        },
        clearAllTournamentTimers(state) {
            Object.values(state.tournamentRoundTimers).forEach(timerId => {
                clearTimeout(timerId);
            });
            state.tournamentRoundTimers = {};
        },
        setShowTournamentModal(state, showTournamentModal) {
            state.showTournamentModal = showTournamentModal
        },
        setClickedTournamentId(state, tournamentId) {
            state.clickedTournamentId = tournamentId
        },
        setCampaignId(state, campaignId) {
            state.campaignId = campaignId
        },
        setFeedArticles(state, feedArticles) {
            state.feedArticles = feedArticles
        },
        setShowAddToHomeScreen(state, showAddToHomeScreen) {
            state.showAddToHomeScreen = showAddToHomeScreen
        },
        setDeferredPrompt(state, defferedPrompt) {
            state.defferedPrompt = defferedPrompt
        },
        setShowUpgradeToPremium(state, showUpgradeToPremium) {
            state.showUpgradeToPremium = showUpgradeToPremium
        },
        setPredictedConstructors(state, predictedConstructors) {
            state.predictedConstructors = predictedConstructors
        },
        setPredictedDrivers(state, predictedDrivers) {
            state.predictedDrivers = predictedDrivers
        },
        setPredictedPolePosition(state, predictedPolePosition) {
            state.predictedPolePosition = predictedPolePosition
        },
        setRoundsEntered(state, roundsEntered) {
            state.roundsEntered = roundsEntered
        },
        setLiveRoundsNotEntered(state, liveRoundsNotEntered) {
            state.liveRoundsNotEntered = liveRoundsNotEntered
        },
        setShowNoQuestions(state, showNoQuestions) {
            state.showNoQuestions = showNoQuestions
        },
        setShowSubUpsell(state, showSubUpsell) {
            state.showSubUpsell = showSubUpsell
        },
        setShowSingleMatch(state, showSingleMatch) {
            state.showSingleMatch = showSingleMatch
        },
        setServiceId(state, serviceId) {
            state.serviceId = serviceId
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setShowInviteFriend(state, showInviteFriend) {
            state.showInviteFriend = showInviteFriend
        },
        setShowEditAvatar(state, showEditAvatar) {
            state.showEditAvatar = showEditAvatar
        },
        setShowEditUserName(state, showEditUserName) {
            state.showEditUserName = showEditUserName
        },
        setShowTriviaGameOver(state, showTriviaGameOver) {
            state.showTriviaGameOver = showTriviaGameOver
        },
        setShowHint(state, showHint) {
            state.showHint = showHint
        },
        setShowSelectCaptain(state, showSelectCaptain) {
            state.showSelectCaptain = showSelectCaptain
        },
        setShowHowToWinPoints(state, showHowToWinPoints) {
            state.showHowToWinPoints = showHowToWinPoints
        },
        setShowAutoTeamBuilder(state, showAutoTeamBuilder) {
            state.showAutoTeamBuilder = showAutoTeamBuilder
        },
        setUpcomingFixtures(state, upcomingFixtures) {
            state.upcomingFixtures = upcomingFixtures
        },
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setUser(state, user) {
            state.user = user
        },
        setRoundId(state, roundId) {
            state.roundId = roundId
        },
        setLeagueName(state, leagueName) {
            state.leagueName = leagueName
        },
        setMyFantasyRounds(state, myFantasyRounds) {
            state.myFantasyRounds = myFantasyRounds
        },
        setMyPredictorRounds(state, myPredictorRounds) {
            state.myPredictorRounds = myPredictorRounds
        },
    },
})
